import React, { useEffect, useState } from 'react'
import ListaFichajes from './ListaFichajes'
import { useAuth } from 'context/AuthProvider';
import { apiFichajesService } from 'services/apiFichajesService';
import { Col } from 'reactstrap';

const FichajesHoyImpl = (props) => {

  

  //empleado
  const { empleado } = useAuth();
  const fecha = new Date().toISOString().split('T')[0];

  const [fichajes, setFichajes] = useState([]);
  useEffect(() => {
      const fetchData = async () => {
          if(fecha){
              const respones = await apiFichajesService.getFichajesEmpleadByEmpleadoIdAndDate(empleado.empresaId, empleado.id, fecha, fecha)
              if (respones) {
                  setFichajes(respones);
                   
                  if (respones.length > 0 && respones[respones.length - 1].tipo === "entrada") {
                      props.setUltimoFichajeEsEntrada(true);
                  } else {
                      props.setUltimoFichajeEsEntrada(false);
                  }
              }
          }
      }
      fetchData();
      
  }, [fecha, props.update, empleado.empresa, empleado.id, props])
  return (
    <>
      {fichajes.length>0 ? <ListaFichajes fichajes={fichajes}></ListaFichajes> : <Col>Sin fichajes...</Col>}
      
    </>
  )
}

export default FichajesHoyImpl